export default "__VITE_ASSET__B2gUxRwN__"